export const preliminaryQuizJson = {
   pages: [
      {
         elements: [
            {
               name: 'question1',
               type: 'radiogroup',
               choices: ['item1', 'item2', 'item3'],
            },
         ],
      },
   ],
};
